export enum ModalShadow {
    None = 'none',
    Dark = 'dark',
    Light = 'light',
}
